import React, { Component } from 'react';
import { FormGroup, Label, Row, Form, Col, CardHeader, Card, CardBody, Spinner, FormFeedback, Input, Alert, Progress, Button } from 'reactstrap';
import _ from 'underscore';
import { Global } from '~/App'
import IngresaCuenta from '~/components/IngresaCuenta'
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import API from '../API';

const loadEvent = new Event('pagaTuCuentaLoaded')

class PagaTuCuenta extends Component {

  constructor(props) {
    super(props);
    this.state = {
      servicio: null,
      loading: true,
      opcionPago: props.location.state && props.location.state.orden ? props.location.state.orden : 0,
      donacion: 0,
      formaPago: null,
      correoValido: null,
      mensajes: []
    };
    this.Consultar = this.Consultar.bind(this);
    try {
      this.inIframe = window.self !== window.top
    } catch {
      this.inIframe = true;
    }
  }

  componentWillMount() {
    this.ConsultaServicio(this.props)
  }

  componentWillReceiveProps(props) {
    this.ConsultaServicio(props)
  }

  ConsultaServicio(props) {
    let locState = props.location.state;
    if (!locState) {
      try {
        let rawSearch = props.location.search || (window.location.search && window.location.search.length > 1 ? window.location.search : "");
        if (!rawSearch && window.location.href && window.location.href.indexOf("?") >= 0) {
          rawSearch = window.location.href.split("?")[1] || "";
        }
        if (!rawSearch && window.top !== window) {
          try { rawSearch = window.top.location.search || ""; } catch (_) {}
        }
        const searchPart = rawSearch.replace(/^\?/, '').split("#")[0];
        const params = new URLSearchParams(searchPart);
        if (params.get("empresa") || params.get("servicio") || params.get("idServicio") || params.get("token")) {
          locState = {
            empresa: params.get("empresa") || "",
            servicio: params.get("servicio") || params.get("idServicio") || "",
            documento: params.get("documento") || null,
            token: params.get("token") || null,
            captcha: params.get("captcha") || null,
            comuna: params.get("comuna") || "",
            calle: params.get("calle") || "",
            noCasa: params.get("noCasa") || "",
            noDpto: params.get("noDpto") || "",
            noCasa2: params.get("noCasa2") || ""
          };
        }
      } catch (e) {}
    }

    if (locState && locState.token && !locState.servicio) {
      this.ConsultarToken(locState.empresa, locState.token);
      return;
    }

    if (!props.Usuario && Global.isAnonBlocked()) {
      props.history.replace("/sucursal");
      return;
    }

    if (locState && locState.empresa && locState.servicio && (locState.captcha || locState.documento || locState.token)) {
      this.Consultar(locState.empresa, locState.servicio, locState.documento, locState.captcha, locState.token);
      if (locState.captcha) {
        props.history.replace({ ...props.location, state: { ...locState, captcha: null } });
      }
    } else if (locState && (locState.captcha || locState.token) && locState.comuna !== "" && locState.calle !== "") {
      this.ConsultarDireccion(locState.empresa, locState.captcha, locState.comuna, locState.calle, locState.noCasa, locState.noDpto, locState.noCasa2, locState.token);
      props.history.replace({ ...props.location, state: { ...locState, captcha: null } });
    } else if (props.Usuario) {
      if (!locState || !locState.servicio) {
        props.history.replace("/sucursal");
      } else {
        this.Consultar(locState.empresa, locState.servicio, null);
      }
    } else {
      if (!this.consultando) {
        this.setState({ loading: false });
      }
    }
  }
  async ConsultarDireccion(empresa, Captcha, Comuna, Calle, NoCasa, NoDpto, NoCasa2, token = null) {
    var formaPago = (Global.empresas.find(o => o.key == empresa) || this.state.servicio || {}).otros?.RecaudadorDefecto;
    try {
      this.consultando = true;
      this.setState({ loading: true });
      var datos = { Captcha, Comuna, Calle, NoCasa, NoDpto, NoCasa2, token };
      var url = `Consulta/${empresa}/Servicio/Direccion`;
      const response = await API.Call(url, datos);
      var recaudadores = Object.entries((Global.empresas.find(o => o.key == (empresa || (this.props.location.state || {}).empresa)) || {}).recaudadores || {}).filter(o => o[1]);
      if (recaudadores.length == 1 && !formaPago) {
        formaPago = recaudadores[0][0];
      }
      this.setState({ formaPago, servicioFalso: response.servicioFalso, deuda: response.deuda, direccion: response.direccion, loading: false, mensajes: [] });
    } catch (e) {
      this.setState({ formaPago, servicio: null, loading: false, mensajes: [{ tipo: "danger", texto: e }] });
    } finally {
      this.consultando = false;
    }
    document.getElementById('Portal-Clientes').scrollIntoView({ behavior: 'smooth', block: 'start' });
    document.getElementById("Portal-Clientes").dispatchEvent(loadEvent);
  }
  async ConsultarToken(empresa, token) {
    var formaPago = (Global.empresas.find(o => o.key == empresa) || this.state.servicio || {}).otros?.RecaudadorDefecto;
    try {
      this.consultando = true;
      this.setState({ loading: true });
      var datos = { token };
      var url = `Consulta/${empresa}/Servicio/Token`;
      const response = await API.Call(url, datos);
      var recaudadores = Object.entries((Global.empresas.find(o => o.key == (empresa || (this.props.location.state || {}).empresa)) || {}).recaudadores || {}).filter(o => o[1]);
      if (recaudadores.length == 1 && !formaPago) {
        formaPago = recaudadores[0][0];
      }
      this.setState({ formaPago, servicioFalso: response.servicioFalso, direccion: response.direccion, deuda: response.deuda, loading: false, mensajes: [] });
    } catch (e) {
      this.setState({ formaPago, servicio: null, loading: false, mensajes: [{ tipo: "danger", texto: e }] });
    } finally {
      this.consultando = false;
    }
    document.getElementById('Portal-Clientes').scrollIntoView({ behavior: 'smooth', block: 'start' });
    document.getElementById("Portal-Clientes").dispatchEvent(loadEvent);
  }

  async Consultar(empresa, servicio, documento, captcha = null, token = null) {
    var formaPago = (Global.empresas.find(o => o.key == empresa) || this.state.servicio || {}).otros?.RecaudadorDefecto;
    try {
      this.consultando = true;
      this.setState({ loading: true })
      var response;
      if (captcha || token) {
        response = await API.Call(`Consulta/${empresa}/Servicio/${servicio}`, { captcha, token });
      } else {
        var url = documento ? `Consulta/${empresa}/Servicio/${servicio}/${documento}`
          : `Consulta/${empresa}/Servicio/${servicio}/Pagar`;
        response = await API.Call(url);
      }
      if (response && response.tokenSesion) {
        try {
          sessionStorage.setItem(`anonToken_${empresa}_${servicio}`, JSON.stringify({ token: response.tokenSesion, ts: Date.now() }));
        } catch {}
      }
      var recaudadores = Object.entries((Global.empresas.find(o => o.key == (empresa || (this.props.location.state || {}).empresa)) || { servicio, ...response }).recaudadores || {}).filter(o => o[1]);
      if (recaudadores.length == 1 && !formaPago) {
        formaPago = recaudadores[0][0];
      }
      this.setState({ formaPago, servicio: { servicio, ...response }, loading: false, mensajes: [] });
    } catch (e) {
      try {
        sessionStorage.removeItem(`anonToken_${empresa}_${servicio}`);
      } catch {}
      this.setState({ formaPago, servicio: null, loading: false, mensajes: [{ tipo: "danger", texto: e }] });
    } finally {
      this.consultando = false;
    }
    document.getElementById('Portal-Clientes').scrollIntoView({ behavior: 'smooth', block: 'start' });
    document.getElementById("Portal-Clientes").dispatchEvent(loadEvent);
  }

  render() {
    var recaudadores = (Global.empresas.find(o => o.key == (this.props.location.state || {}).empresa) || this.state.servicio || {}).recaudadores || {};
    if (this.state.servicioFalso) {
      return (
        <Card>
          <CardHeader className="titulo-modal paga-tu-cuenta"><span>Paga tu Cuenta</span></CardHeader>
          <CardBody className="cuerpo-modal">
            <Row>
              <Col sm={{ size: 8, offset: 2 }}>
                <div className="cuadroPago">
                  <h4>Total a Pagar</h4>
                  <br />
                  {/* {this.props.location.state.token? */}<p>Usted está pagando: {Global.toTitleCase(this.state.direccion)}</p>{/* :
                <p>{`Usted está pagando: ${Global.toTitleCase(this.props.location.state.calle)} ${Global.toTitleCase(this.props.location.state.noCasa)}${this.props.location.state.noDpto ? (", " + Global.toTitleCase(this.props.location.state.noDpto)) : ""}${this.props.location.state.noCasa2? (", "+Global.toTitleCase(this.props.location.state.noCasa2)) : ""}, ${Global.toTitleCase(this.props.location.state.comuna)}`}</p>} */}
                  <br />
                  <p className="float-left">
                    <h6 style={{ display: "inline" }}>Deuda</h6>
                  </p>
                  <p className="float-right">
                    <strong><h6 style={{ display: "inline" }}>$ {Global.FormatearNumero(this.state.deuda)}</h6></strong>
                  </p>
                  <div style={{ clear: "both" }}></div>
                  {!this.props.Usuario && <Link to="/registrate">Regístrate para ver tus documentos históricos</Link>}
                  <hr />
                  <p className="float-left">
                    <h5 style={{ display: "inline" }}>Total</h5>
                  </p>
                  <p className="float-right">
                    <strong><h5 style={{ display: "inline" }}>$ {Global.FormatearNumero(this.state.deuda)}</h5></strong>
                  </p>
                  <div style={{ clear: "both" }}></div>
                  <br />
                  <Form method="post" target={this.inIframe ? "_blank" : null} action={this.state.formaPago ? `${Global.UrlApi}/Recaudacion/${(this.props.location.state || {}).empresa}/OrdenDePago/${Global.toTitleCase(this.state.formaPago)}/Generar/Direccion` : ""}>
                    {!this.props.Usuario &&
                      <FormGroup>
                        <Label for="correo"><h6>Correo electrónico</h6>
                          <small>Para enviar Comprobante de Pago</small></Label>
                        <Input invalid={!this.state.correoValido} onChange={e => this.setState({ correoValido: Global.ValidateEmail(e.target.value) })} bsSize="sm" type="email" name="correo" placeholder="Ingrese su Correo" />
                        <FormFeedback>Debe ser un correo válido</FormFeedback>
                        <br />
                      </FormGroup>}
                    <h6>Forma de Pago</h6>
                    <div className="d-flex flex-wrap justify-content-center my-3">
                      {Object.keys(recaudadores).filter(rec => recaudadores[rec]).sort().map(rec => (
                        <div key={rec} className="m-2" style={rec === 'linkpago' ? { display: 'none' } : {}}>
                          <Label check className="forma-pago-label">
                            <Input type="radio" name="formaPago" checked={this.state.formaPago === rec} onChange={() => this.setState({ formaPago: rec })} />
                            <img src={Global.logosRecaudadores[rec]} alt={rec} />
                          </Label>
                        </div>
                      ))}
                    </div>
                    <p>
                      {API.Cookie && <input type="hidden" name="token" value={API.Cookie} />}
                      <input type="hidden" name="monto" value={this.state.deuda} />
                      <input type="hidden" name="servicioFalso" value={this.state.servicioFalso} />
                      <Button style={{ marginTop: "2rem", float: "right" }} /* onClick={this.Pagar} */ color="primary" disabled={!this.state.formaPago || !this.state.deuda || (!this.props.Usuario && !this.state.correoValido)}>Pagar</Button>
                    </p>
                    <div style={{ clear: "both" }}></div>
                  </Form>
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>

      );
    }
    var pago = this.state.servicio && (_.isEmpty(this.state.servicio.Documentos) ? 0 : this.state.servicio.Documentos[this.state.opcionPago].aPagar) + this.state.donacion;
    return (
      <div>
        {!this.props.location.state || (!this.state.servicio && !this.state.loading) ?
          <Card>
            <CardHeader className="titulo-modal paga-tu-cuenta"><span>Paga tu Cuenta</span></CardHeader>
            <CardBody className="cuerpo-modal">
              <Row>
                <Col sm={{ size: 6, offset: 3 }} className="bordeCompleto">
                  <h4 className="text-muted ingrese-datos-cuenta"><small><span>Ingrese los datos de su cuenta</span></small></h4>
                  <Link to={"/sucursal"}>{"Tienes cuenta? Inicia Sesión"}</Link>
                  <br />
                  {_.map(this.state.mensajes, (m, i) => <Alert key={i} color={m.tipo}>
                    {m.texto}
                  </Alert>)
                  }
                  <br />
                  <IngresaCuenta {...this.props} />
                </Col>
              </Row>
            </CardBody>
          </Card>
          :
          this.state.loading ?
            <Spinner animation="border" role="status">
              {"Cargando..."}
              {/* <span className="sr-only">Cargando...</span> */}
            </Spinner> :
            <Card>
              <CardHeader className="titulo-modal paga-tu-cuenta"><span>Paga tu Cuenta</span></CardHeader>
              <CardBody className="cuerpo-modal">
                <Row>
                  <Col lg={7} md={6} className="bordeIzquierdoSimple mb-4 mb-md-0">
                    <h4>Detalle de la Cuenta</h4>
                    <hr />
                    <h5>Cuenta {Global.AgregaDV(this.state.servicio.servicio)}</h5>
                    <p className="text-muted">{(Global.empresas.find(o => o.key == (this.props.location.state || {}).empresa) || { nombre: this.state.servicio.nombreEmpresa }).nombre}</p>

                    {this.state.servicio.deuda_vencida > 0 &&
                      <Alert color="danger">
                        <strong>Atención:</strong> {this.state.servicio.estado_corte}
                      </Alert>}

                    {_.isEmpty(this.state.servicio.Documentos) ?
                      <Alert color="success">No tienes deuda pendiente.</Alert> :
                      <div>
                        <Row>
                          <Col sm={12}>
                            {_.isEmpty(this.state.servicio.Documentos) ?
                              <Alert color="success">
                                Sin deuda
                              </Alert> :
                              <div className="text-center">
                                <Progress style={{ minHeight: "3rem", marginBottom: "1rem" }} multi>
                                  <Progress bar color="danger" value={this.state.servicio.deuda_vencida} max={this.state.servicio.deuda_actual}><strong>Deuda Vencida</strong><h6>$ {Global.FormatearNumero(this.state.servicio.deuda_vencida)}</h6></Progress>
                                  <Progress bar color="primary" value={this.state.servicio.deuda_actual - this.state.servicio.deuda_vencida} max={this.state.servicio.deuda_actual}><strong>Deuda Sin Vencer</strong><h6>$ {Global.FormatearNumero(this.state.servicio.deuda_actual - this.state.servicio.deuda_vencida)}</h6></Progress>
                                </Progress>
                              </div>}
                          </Col>
                        </Row>
                      </div>
                    }

                    <hr />
                    <h4>Datos Generales</h4>
                    <Row>
                      <Col sm={4} className="font-weight-bold">Titular</Col>
                      <Col sm={8}>{Global.toTitleCase(this.state.servicio.nom_cliente)}</Col>
                    </Row>
                    <Row>
                      <Col sm={4} className="font-weight-bold">Dirección</Col>
                      <Col sm={8}>{Global.toTitleCase(this.state.servicio.dir_instal)}, {Global.toTitleCase(this.state.servicio.comuna_instal)}</Col>
                    </Row>
                    {!this.props.Usuario && <div className="mt-3"><Link to="/registrate">Regístrate para ver tus documentos históricos</Link></div>}
                  </Col>

                  <Col lg={5} md={6}>
                    <h4>Opciones de Pago</h4>
                    <hr />
                    <div className="opcionesPago">
                      {this.state.servicio.Documentos.map((d, i) =>
                        <div key={i} className={"opcionPagar" + (i == this.state.opcionPago ? " seleccionada" : "")} onClick={() => this.setState({ opcionPago: i })}>
                          {d.nombre_movimiento} {d.aPagar <= this.state.servicio.deuda_vencida ? <span className="text-danger font-weight-bold">(Vencida)</span> : ""}<br />
                          <strong>$ {Global.FormatearNumero(d.aPagar)}</strong>
                        </div>
                      )}
                      {this.state.servicio.donacion_a_pagar ?
                        <div className={"opcionPagar" + (this.state.donacion == this.state.servicio.donacion_a_pagar ? " seleccionada" : "")} onClick={() => this.setState({ donacion: this.state.donacion == this.state.servicio.donacion_a_pagar ? 0 : this.state.servicio.donacion_a_pagar })}>
                          Donación<br />
                          <strong>$ {Global.FormatearNumero(this.state.servicio.donacion_a_pagar)}</strong>
                        </div> : null}
                    </div>

                    <div className="cuadroPago mt-4">
                      <div className="d-flex justify-content-between align-items-center">
                        <h5>Total a Pagar</h5>
                        <h5><strong>$ {_.isEmpty(this.state.servicio.Documentos) ? 0 : Global.FormatearNumero(this.state.servicio.Documentos[this.state.opcionPago].aPagar + this.state.donacion)}</strong></h5>
                      </div>
                      <hr />
                      <Form method="post" target={this.inIframe ? "_blank" : null} action={this.state.formaPago ? `${Global.UrlApi}/Recaudacion/${(this.props.location.state || {}).empresa}/OrdenDePago/${Global.toTitleCase(this.state.formaPago)}/Generar` : ""}>
                        {!this.props.Usuario &&
                          <FormGroup>
                            <Label for="correo"><h6>Correo electrónico</h6>
                              <small className='text-muted'>Para enviar Comprobante de Pago</small></Label>
                            <Input invalid={!this.state.correoValido} onChange={e => this.setState({ correoValido: Global.ValidateEmail(e.target.value) })} bsSize="sm" type="email" name="correo" placeholder="Ingrese su Correo" />
                            <FormFeedback>Debe ser un correo válido</FormFeedback>
                          </FormGroup>}
                        <h6>Forma de Pago</h6>
                        <div className="d-flex flex-wrap justify-content-center my-3">
                          {Object.keys(recaudadores).filter(rec => recaudadores[rec]).sort().map(rec => (
                            <div key={rec} className="m-2" style={rec === 'linkpago' ? { display: 'none' } : {}}>
                              <Label check className="forma-pago-label">
                                <Input type="radio" name="formaPago" checked={this.state.formaPago === rec} onChange={() => this.setState({ formaPago: rec })} />
                                <img src={Global.logosRecaudadores[rec]} alt={rec} />
                              </Label>
                            </div>
                          ))}
                        </div>
                        {API.Cookie && <input type="hidden" name="token" value={API.Cookie} />}
                        <input type="hidden" name="monto" value={pago} />
                        <input type="hidden" name="id_servicio" value={this.state.servicio.servicio} />
                        <input type="hidden" name="noDoc" value={!_.isEmpty(this.state.servicio.Documentos) ? this.state.servicio.Documentos[this.state.opcionPago].numero : null} />
                        <Button block color="primary" size="lg" disabled={!this.state.formaPago || !pago || (!this.props.Usuario && !this.state.correoValido)}>Pagar</Button>
                      </Form>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>}
      </div>
    );
  }
}

export default withRouter(PagaTuCuenta);